import { IOrderStatus, IParsedMerchantIntegration } from "../interfaces/order";

export interface IOrdersFiltersUIErrors {
  from: boolean;
  to: boolean;
  invalidFrom: boolean;
  invalidTo: boolean;
}

export interface IOrdersFiltersUIPicker {
  fromDate: string | Date | null | undefined;
  toDate: string | Date | null | undefined;
}

export interface IOrdersFiltersUIState {
  statusList: IOrderStatus[];
  selectedCarriers: string[];
  selectedIds: string[];
  selectedStatus: string;
  selectedStatuses: IOrderStatus[];
  selectedSlaAlertLevels: string[];
  picker: IOrdersFiltersUIPicker;
  searchValue: string;
  activeSearch: boolean;
  merchants: IParsedMerchantIntegration[];
  selectedMerchantId?: number;
  errors: IOrdersFiltersUIErrors;
}

export type TOrdersFiltersUIAction =
  | { type: "setStatusList"; value: IOrderStatus[] }
  | { type: "setSelectedCarriers"; value: string[] }
  | { type: "setSelectedIds"; value: string[] }
  | { type: "setSelectedStatus"; value: string }
  | { type: "setSelectedStatuses"; value: IOrderStatus[] }
  | { type: "setSelectedSlaAlertLevels"; value: string[] }
  | { type: "setPickerField"; key: keyof IOrdersFiltersUIPicker; value: IOrdersFiltersUIPicker[keyof IOrdersFiltersUIPicker] }
  | { type: "setPicker"; value: IOrdersFiltersUIPicker }
  | { type: "setSearchValue"; value: string }
  | { type: "setActiveSearch"; value: boolean }
  | { type: "setMerchants"; value: IParsedMerchantIntegration[] }
  | { type: "setSelectedMerchantId"; value: number | undefined }
  | { type: "setErrors"; value: IOrdersFiltersUIErrors }
  | { type: "resetAll" };

export const defaultUIErrors: IOrdersFiltersUIErrors = {
  from: false,
  to: false,
  invalidFrom: false,
  invalidTo: false,
};

export const initialOrdersFiltersUIState: IOrdersFiltersUIState = {
  statusList: [],
  selectedCarriers: [],
  selectedIds: [],
  selectedStatus: "",
  selectedStatuses: [],
  selectedSlaAlertLevels: [],
  picker: { fromDate: null, toDate: null },
  searchValue: "",
  activeSearch: false,
  merchants: [],
  selectedMerchantId: undefined,
  errors: defaultUIErrors,
};

export const ordersFiltersUIReducer = (
  state: IOrdersFiltersUIState,
  action: TOrdersFiltersUIAction
): IOrdersFiltersUIState => {
  switch (action.type) {
  case "setStatusList":
    return { ...state, statusList: action.value };
  case "setSelectedCarriers":
    return { ...state, selectedCarriers: action.value };
  case "setSelectedIds":
    return { ...state, selectedIds: action.value };
  case "setSelectedStatus":
    return { ...state, selectedStatus: action.value };
  case "setSelectedStatuses":
    return { ...state, selectedStatuses: action.value };
  case "setSelectedSlaAlertLevels":
    return { ...state, selectedSlaAlertLevels: action.value };
  case "setPickerField":
    return { ...state, picker: { ...state.picker, [action.key]: action.value } };
  case "setPicker":
    return { ...state, picker: action.value };
  case "setSearchValue":
    return { ...state, searchValue: action.value };
  case "setActiveSearch":
    return { ...state, activeSearch: action.value };
  case "setMerchants":
    return { ...state, merchants: action.value };
  case "setSelectedMerchantId":
    return { ...state, selectedMerchantId: action.value };
  case "setErrors":
    return { ...state, errors: action.value };
  case "resetAll":
    return {
      ...state,
      selectedMerchantId: undefined,
      picker: { fromDate: null, toDate: null },
      searchValue: "",
      activeSearch: false,
      selectedStatus: "",
      selectedStatuses: [],
      selectedCarriers: [],
      selectedIds: [],
      selectedSlaAlertLevels: [],
    };
  default:
    return state;
  }
};
